import moment from 'moment';
const Helpers = {
	convertUtcToTimezone: function(rows, format) {
		return moment(rows).format(format)
	}

}
export default Helpers;